const DeliveryMethodDescription = (freeShipping: boolean): string => {
  return freeShipping ? 'Free express shipping worldwide' : 'Express shipping';
};

export default DeliveryMethodDescription;
